// extracted by mini-css-extract-plugin
export var anchor = "bq_fk";
export var anchors = "bq_fj";
export var document = "bq_fn";
export var documents = "bq_fm";
export var heading = "bq_G";
export var privacy = "bq_fl";
export var section = "bq_d";
export var tariff = "bq_fq";
export var tariffs = "bq_fp";